import { Link } from 'gatsby'
import styled, { keyframes, FlattenSimpleInterpolation } from 'styled-components'
import breakpoints from '../../styles/breakpoints'
import { white, orange } from '../../styles/colors'

const fixedHeader = keyframes`
  from {
    top:-60px;
  }
  to {
    top:0;
  }
`
interface IHeader {
  customHeaderStyle?: FlattenSimpleInterpolation;
}

export const Header = styled.header<IHeader>`
  background-color: ${white};
  left: 0;
  max-height: 55px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
  padding: 17px 0 17px 0;
  
  @media (min-width: ${breakpoints.lg}) {
    padding: 20px 0 20px 0;
    max-height: 75px;
  }

  &.drop-menu {
    animation-name: ${fixedHeader};
    animation-duration: .5s;
    align-items: center;
    background: linear-gradient(183deg, #FF8700, #FF500F);
    box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    height: 55px;
    position: fixed;
    z-index: 10;
    
    @media (min-width: ${breakpoints.lg}) {
      height: 75px;
    }

    .logo-link svg path {
      fill: ${white} !important;
    }
    .icon-chevron svg path {
      fill: ${orange} !important;

      @media (min-width: ${breakpoints.lg}) {
        fill: ${white} !important;
      }
    }
  }

  ${(props: IHeader) => props.customHeaderStyle}
`

export const LogoLink = styled(Link)`
  display: inline-block;
  margin-left: 35px;
  margin-top: -5px;

  @media (min-width: ${breakpoints.md}) {
    margin-left: 15px;
  }

  @media (min-width: ${breakpoints.lg}) {
    margin-left: 0;
  }

  svg {
    path {
      fill: ${orange};
    }   
  }
`
